import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { supabase } from "@/shared/lib/supabase";
import { AuthTemplate } from "@modootoday/ui-widgets/templates";

export function AuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.onAuthStateChange((event, session) => {
      if ((event === "SIGNED_IN" || event === "INITIAL_SESSION") && session) {
        const next = new URLSearchParams(window.location.search).get("next");
        if (next && !next.startsWith("/auth/")) {
          window.location.assign(next);
        } else {
          navigate({ to: "/dashboard" });
        }
      }
    });
  }, [navigate]);

  return (
    <AuthTemplate
      title="인증 처리 중..."
      subtitle="잠시만 기다려 주세요. 인증 정보를 확인하고 있습니다."
    >
      <div className="flex justify-center py-6">
        <div className="size-12 animate-spin rounded-full border-4 border-accent/30 border-t-accent" />
      </div>
    </AuthTemplate>
  );
}
